import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { MARKETING_CENTER_PATH } from '@constant'
import VersionBox from './versionBox'
import style from './index.module.less'
import Store from './store'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.getData()
    // this.store.getBuyInfo()
  }
  render() {
    const standard_price = toJS(this.store.standard_price)
    const flagship_price = toJS(this.store.flagship_price)
    const standard_to_flagship = toJS(this.store.standard_to_flagship)
    return (
      <HeaderView
        header={[
          <Link to={MARKETING_CENTER_PATH}>服务市场</Link>,
          <Link to="/localMerchant/marketingCenter/shopProduct">店铺产品</Link>,
          '选择产品'
        ]}
        title="选择产品"
      >
        <h3 className={style.title}>请选择店铺版本</h3>
        <p className={style.tip}>线上店铺经营 一体化解决方案</p>
        <div className={style['purchase-wrap']}>
          <VersionBox
            type="standard"
            {...standard_price}
            standard_to_flagship={standard_to_flagship}
          />
          <VersionBox
            type="pro"
            {...flagship_price}
            standard_to_flagship={standard_to_flagship}
          />
        </div>
      </HeaderView>
    )
  }
}

export default Index
